import React, { useState, useEffect, useRef } from "react";
import EmojiPicker from "@emoji-mart/react";
import ErrorBoundary from "./ErrorBoundary";

const MAX_RETRIES = 3;

type Props = {
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  containerClassName: string;
  onEmojiSelect: (emoji: any) => void;
  [key: string]: any;
};

const EmojiPickerCustom = ({ isOpen, setIsOpen, containerClassName, ...pickerProps }: Props) => {
  const [initialized, setInitialized] = useState(false);
  const [retryCount, setRetryCount] = useState(0);
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (isOpen && !initialized) setInitialized(true);
  }, [isOpen]);

  useEffect(() => {
    if (!isOpen) return;

    const handleClickOutside = (e: MouseEvent) => {
      if (containerRef.current && !containerRef.current.contains(e.target as Node)) {
        setIsOpen(false);
      }
    };

    const timeoutId = setTimeout(() => {
      document.addEventListener("click", handleClickOutside);
    }, 0);

    return () => {
      clearTimeout(timeoutId);
      document.removeEventListener("click", handleClickOutside);
    };
  }, [isOpen]);

  if (!initialized) return null;

  return (
    <ErrorBoundary
      key={retryCount}
      onError={() => { if (retryCount < MAX_RETRIES) setRetryCount((c) => c + 1); }}
    >
      <div ref={containerRef} className={`${isOpen ? "" : "hidden"} ${containerClassName}`}>
        <EmojiPicker {...pickerProps} />
      </div>
    </ErrorBoundary>
  );
};

export default EmojiPickerCustom;
